export default __webpack_public_path__ + "static/media/PetarC.3e625d85.png";